import { useEffect, useState } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { SplashScreen } from '@tankef/ui';

import { AppInitializer } from '../providers/AppInitializer';

import {
  useClientIsAuthenticated,
  useClientIsLoading,
  useTokenRefresh,
} from '@/domains/identity/auth/api';

let protectedInitialCheckCompleted = false;

export function ProtectedRoute() {
  const isAuthenticated = useClientIsAuthenticated();
  const isLoading = useClientIsLoading();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(!protectedInitialCheckCompleted);

  useTokenRefresh();

  useEffect(() => {
    if (!isLoading && isChecking) {
      const timer = setTimeout(() => {
        setIsChecking(false);
        protectedInitialCheckCompleted = true;
      }, 500);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [isLoading, isChecking]);

  if (isChecking) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <AppInitializer />
      <Outlet />
    </>
  );
}
